<template>
<!-- 指派组件 -->
  <el-dialog title="指派" :visible.sync="dialog" @close="closeDialog" :close-on-click-modal="false" width="1100px" center>
        <!-- 内容 -->
        <div>
          <div class="addressBox">
            <h4 class="title"  v-if="assignType != 5">
              <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>指派承运方</span>
            </h4>
          </div>
          <el-tabs v-model="activeName" >
            <el-tab-pane label="司机" name="second" v-if="assignType != 5">
              <!-- 头部查询 -->
              <el-form :inline="true" :model="SJsearchFrom" ref="SJsearchFrom" class="demo-form-inline" label-width="110px" size="mini">
                <div class=" inpBox">
                  <el-form-item label="司机姓名:" prop="driverName">
                    <el-input  placeholder="" v-model.trim="SJsearchFrom.driverName"></el-input>
                  </el-form-item>
                  <el-form-item label="身份证号:" prop="identityNo">
                    <el-input  placeholder="" v-model.trim="SJsearchFrom.identityNo"></el-input>
                  </el-form-item>
                      <el-form-item >
                    <el-button type="primary" @click="SJsearchFn">查询</el-button>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="primary" @click="resetForm()">重置</el-button>
                  </el-form-item>
                </div>
              </el-form>
              <!-- 表格数据 -->
              <div>
                <!-- 表格 -->
                <div>
                  <el-table
                    :data="SJList"
                    ref="table"
                    v-loading="loading"
                    bordersize="mini"
                    @row-click="handleRowClick"
                    class="table"
                    height="380px"
                    style="width: 100%"
                    center
                    border
                  >
                    <!-- <el-table-column type="selection" width="30" :reserve-selection="true"></el-table-column> -->
                    <el-table-column  type="index" width="55" label="序号"></el-table-column>
                    <el-table-column label="操作" width="80">
                      <template slot-scope="scope">
                        <el-button type="text"  @click="SJZPfn(scope.row,2)" size="mini">指派</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" min-width="120" :show-overflow-tooltip="true"  label="司机姓名"></el-table-column>
                    <el-table-column prop="mobile" width="150" label="联系电话"></el-table-column>
                     <el-table-column property="identityNo" label="身份证号" width="200">
                      <template scope="scope">
                        <p v-if="scope.row.tenantId!=tenantCode">
                          {{scope.row.identityNo.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}}
                        </p>
                        <p v-else>{{scope.row.identityNo}}</p>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 分页 -->
                <div>
                  <el-pagination background
                    @size-change="SJhandleSizeChange"
                    @current-change="SJhandleCurrentChange"
                    :current-page="SJsearchFrom.pageNo"
                    :page-sizes="[25,50,100]"
                    :page-size="SJsearchFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="SJtotal">
                  </el-pagination>
                </div>
              </div>
               <el-dialog append-to-body title="选择车辆" :visible.sync="carMark"  :close-on-click-modal="false" width="900px" center>
        <!-- 内容 -->
        <div>
          <!-- 表格数据 -->
          <div class="tableQiye">
            <!-- 表格 -->
            <div>
              <el-table :data="carList" ref="table" v-loading="loading" bordersize="mini"
                @row-click="handleRowClick"  class="table" height="380px" style="width: 100%"   center  border   >
                <el-table-column type="index" width="55" label="序号"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text"  @click="carOk(scope.row)" size="mini">选择车辆</el-button>
                  </template>
                </el-table-column>
               <el-table-column prop="vhcNo"  width="100" label="车牌号"></el-table-column>
                <el-table-column prop="vhcTypeName"  width="150" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
                <el-table-column property="vehicleTenantName" width="240"  :show-overflow-tooltip="true" label="所属单位/个人" > </el-table-column>
                <el-table-column prop="energyName"  width="150" :show-overflow-tooltip="true" label="能源类型"></el-table-column>
                <el-table-column prop="drivingLicense" width="170"  :show-overflow-tooltip="true" label="行驶证号"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
         <span slot="footer" class="dialog-footer">
          <el-button @click="carMark=false">关闭</el-button>
        </span>
      </el-dialog>
            </el-tab-pane>
            <!-- 2023.05.09改，屏蔽掉车队、车队长 -->
            <!-- <el-tab-pane label="车队长" name="three" v-if="assignType != 4">
              <el-form :inline="true" :model="CDZsearchFrom" ref="CDZsearchFrom" class="demo-form-inline" label-width="110px" size="mini">
                <div class=" inpBox">
                  <el-form-item label="车队长名称:" prop="tenantName">
                    <el-input  placeholder="" v-model.trim="CDZsearchFrom.tenantName"></el-input>
                  </el-form-item>
                   <el-form-item label="身份证号:" prop="taxpayerNumber">
                    <el-input  placeholder="" v-model.trim="CDZsearchFrom.taxpayerNumber"></el-input>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="primary" @click="CDZsearchFn">查询</el-button>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="primary" @click="resetForm()">重置</el-button>
                  </el-form-item>
                </div>
              </el-form>
              <div class="tableQiye">
                <div>
                  <el-table
                    :data="CDZList"
                    ref="table"
                    v-loading="loading"
                    bordersize="mini"
                    class="table"
                    height="380px"
                    style="width: 100%"
                    center
                    border
                  >
                    <el-table-column type="index" width="55" label="序号"></el-table-column>
                    <el-table-column label="操作" width="80">
                      <template slot-scope="scope">
                        <el-button type="text"  @click="QYZPfn(scope.row,3)" size="mini">{{assignType==5?'选择':'指派'}}</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column prop="tenantName" min-width="240" :show-overflow-tooltip="true"  label="车队长名称"></el-table-column>
                    <el-table-column prop="taxpayerNumber" min-width="120" :show-overflow-tooltip="true"  label="身份证">
                      <template scope="scope">
                        <p >{{scope.row.taxpayerNumber.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}} </p>
                      </template>
                    </el-table-column>
                    <el-table-column prop="contactsMoblie" width="150" label="联系电话"></el-table-column>
                  </el-table>
                </div>
                <div>
                  <el-pagination background
                    @size-change="CDZhandleSizeChange"
                    @current-change="CDZhandleCurrentChange"
                    :current-page="CDZsearchFrom.pageNo"
                    :page-sizes="[25,50,100]"
                    :page-size="CDZsearchFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="CDZtotal">
                  </el-pagination>
                </div>
              </div>
            </el-tab-pane> -->
            <!-- <el-tab-pane label="车队企业" name="first" v-if="assignType != 4&&assignType != 5">
              <el-form :inline="true" :model="QYsearchFrom" ref="QYsearchFrom" class="demo-form-inline" label-width="110px" size="mini">
                <div class=" inpBox">
                  <el-form-item label="企业名称:" prop="tenantName">
                    <el-input  placeholder="" v-model.trim="QYsearchFrom.tenantName"></el-input>
                  </el-form-item>
                      <el-form-item >
                    <el-button type="primary" @click="QYsearchFn">查询</el-button>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="primary" @click="resetForm()">重置</el-button>
                  </el-form-item>
                </div>
              </el-form>
              <div class="tableQiye">
                <div>
                  <el-table
                    :data="QYList"
                    ref="table"
                    v-loading="loading"
                    bordersize="mini"
                    class="table"
                    height="380px"
                    style="width: 100%"
                    center
                    border
                  >
                    <el-table-column type="index" width="55" label="序号"></el-table-column>
                    <el-table-column label="操作" width="80">
                      <template slot-scope="scope">
                        <el-button type="text"  @click="QYZPfn(scope.row,1)" size="mini">指派</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column prop="tenantName" min-width="240" :show-overflow-tooltip="true"  label="企业"></el-table-column>
                    <el-table-column prop="contactsName" min-width="120" :show-overflow-tooltip="true"  label="联系人"></el-table-column>
                    <el-table-column prop="contactsMoblie" width="150" label="联系电话"></el-table-column>
                  </el-table>
                </div>
                <div>
                  <el-pagination background
                    @size-change="QYhandleSizeChange"
                    @current-change="QYhandleCurrentChange"
                    :current-page="QYsearchFrom.pageNo"
                    :page-sizes="[25,50,100]"
                    :page-size="QYsearchFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="QYtotal">
                  </el-pagination>
                </div>
              </div>
            </el-tab-pane> -->
          </el-tabs>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialog = false">关 闭</el-button>
        </span>
      </el-dialog>
</template>

<script>
import { assignCaptainDriverList, getCVehicleInfoListByDriverId } from '@/api/vgs-driver2.0'
import { getAllTenantFleet, getAllCDZUser } from '@/api/soc-customer'
export default {
  name: 'assign',
  props: ['assignType', 'weight'],
  data () {
    return {
      tenantCode: '',
      dialog: false,
      activeName: 'second',
      loading: false,
      ZPFrom: {
        fatePrice: 0
      },
      rules: {
        pricingMethod: [
          { required: true, message: '请选择计价方式', trigger: 'blur' }
        ],
        unitPrice: [
          { required: true, message: '请输入价格', trigger: 'blur' }
        ]
      },
      jjfangshi: [
        { val: 1, name: '单价' },
        { val: 2, name: '包干' }
      ],
      SJsearchFrom: {
        pageNo: 1,
        pageSize: 50,
        type: 1, // 代表货主指派
        tenantId: this.tenantCode
      },
      SJList: [],
      SJtotal: 0,
      // 选择车辆
      carMark: false,
      carList: [],
      QYsearchFrom: {// 企业
        pageNo: 1,
        pageSize: 50,
        sysModel: '车队业务',
        tenantId: this.tenantCode
      },
      QYList: [],
      QYtotal: 0,
      // 车队长
      CDZsearchFrom: {
        pageNo: 1,
        pageSize: 50,
        sysModel: '车队业务',
        tenantId: this.tenantCode
      },
      CDZList: [],
      CDZtotal: 0
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.dialog = true
    this.tenantCode = localStorage.getItem('tenantCode')
    if (this.assignType == 4) {
      this.activeName = 'second'
      this.SJgetList(this.SJsearchFrom)
    } else if (this.assignType == 5) {
      this.activeName = 'three'
      this.CDZgetList(this.CDZsearchFrom)
    } else {
      this.SJgetList(this.SJsearchFrom)
      this.QYgetList(this.QYsearchFrom)
      this.CDZgetList(this.CDZsearchFrom)
    }
  },
  methods: {
    // 司机指派
    SJZPfn (row, n) {
      let that = this
      if (this.assignType == 1) { // 平台
        this.$refs.ZPFrom.validate((valid) => {
          if (valid) {
            fuzhi()
          } else {
            return false
          }
        })
      } else if (this.assignType == 3 || this.assignType == 4 || this.assignType == 5) { // 货主
        that.ZPFrom.carriageType = n
        fuzhi()
      }
      function fuzhi () {
        that.ZPFrom.driverId = row.id
        that.ZPFrom.identityNo = row.identityNo
        that.ZPFrom.driverName = row.name
        that.ZPFrom.mobile = row.mobile
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        getCVehicleInfoListByDriverId({ driverId: row.id }).then(res => {
          loading.close()
          if (res.length == 0) {
            that.$alert('该司机下暂无审核通过的车辆', '系统提示')
          } else if (res.length == 1) {
            that.carOk(res[0])
          } else {
            that.carMark = true
            that.carList = res
          }
        })
      }
    },
    carOk (row) {
      this.ZPFrom.vhcId = row.id
      this.ZPFrom.vhcNo = row.vhcNo
      this.ZPFrom.vhcNoColor = row.noColourCode
      this.ZPFrom.businessLicenseNo = row.businessLicenseNo
      this.ZPFrom.trailerNo = row.trailerNo // 挂车牌号
      this.$emit('selectCar', this.ZPFrom)
      console.log(this.ZPFrom, 'this.ZPFrom')
    },
    // 企业指派
    QYZPfn (row, n) {
      let that = this
      if (this.assignType == 1) { // 平台
        this.$refs.ZPFrom.validate((valid) => {
          if (valid) {
            fuzhi()
          } else {
            return false
          }
        })
      } else if (this.assignType == 3 || this.assignType == 4 || this.assignType == 5) { // 货主
        fuzhi()
      }
      function fuzhi () {
        that.ZPFrom.fleetId = row.tenantCode
        that.ZPFrom.fleetName = row.tenantName
        that.ZPFrom.CustomerTaxId = row.taxpayerNumber
        that.ZPFrom.mobile = row.contactsMoblie
        that.ZPFrom.carriageType = n
        that.$emit('selectFleet', that.ZPFrom)
      }
    },
    // 查选
    SJsearchFn () {
      this.SJgetList(this.SJsearchFrom)
    },
    // 获取列表
    SJgetList (searchFrom) {
      if (this.SJsearchFrom.driverName || this.SJsearchFrom.identityNo) {
        this.SJsearchFrom.tenantId = ''
      } else {
        this.SJsearchFrom.tenantId = this.tenantCode
      }
      assignCaptainDriverList(searchFrom).then(res => {
        this.SJList = res.list
        this.SJtotal = res.total
      })
    },
    // 每页条数
    SJhandleSizeChange (val) {
      this.SJsearchFrom.pageSize = val
      this.SJgetList(this.SJsearchFrom)
    },
    // 当前页
    SJhandleCurrentChange (val) {
      this.SJsearchFrom.pageNo = val
      this.SJgetList(this.SJsearchFrom)
    },
    // 查选
    QYsearchFn () {
      this.QYgetList(this.QYsearchFrom)
    },
    // 获取列表
    QYgetList (searchFrom) {
      if (this.QYsearchFrom.tenantName) {
        this.QYsearchFrom.tenantId = ''
      } else {
        this.QYsearchFrom.tenantId = this.tenantCode
      }
      getAllTenantFleet(searchFrom).then(res => {
        this.QYList = res.list
        this.QYtotal = res.total
      })
    },
    // 每页条数
    QYhandleSizeChange (val) {
      this.QYsearchFrom.pageSize = val
      this.QYgetList(this.QYsearchFrom)
    },
    // 当前页
    QYhandleCurrentChange (val) {
      this.QYsearchFrom.pageNo = val
      this.QYgetList(this.QYsearchFrom)
    },
    // 查选
    CDZsearchFn () {
      this.CDZgetList(this.CDZsearchFrom)
    },
    // 获取列表
    CDZgetList (searchFrom) {
      if (this.CDZsearchFrom.tenantName || this.CDZsearchFrom.taxpayerNumber) {
        this.CDZsearchFrom.tenantId = ''
      } else {
        this.CDZsearchFrom.tenantId = this.tenantCode
      }
      getAllCDZUser(searchFrom).then(res => {
        this.CDZList = res.list
        this.CDZtotal = res.total
      })
    },
    // 每页条数
    CDZhandleSizeChange (val) {
      this.CDZsearchFrom.pageSize = val
      this.CDZgetList(this.CDZsearchFrom)
    },
    // 当前页
    CDZhandleCurrentChange (val) {
      this.CDZsearchFrom.pageNo = val
      this.CDZgetList(this.CDZsearchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 重置
    resetForm (formName) {
      this.SJsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        type: 1, // 代表货主指派
        tenantId: this.tenantCode
      }
      this.QYsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        sysModel: '车队业务',
        tenantId: this.tenantCode
      }
      this.CDZsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        sysModel: '车队业务',
        tenantId: this.tenantCode
      }
      this.ccarFrom = {}
    },
    closeDialog () {
      this.$emit('destroy')
      this.SJsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        tenantId: this.tenantCode
      }
      this.QYsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        sysModel: '车队业务'
      }
      this.CDZsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        sysModel: '车队业务'
      }
      this.ccarFrom = {}
    },
    closeDialog1 () {
      this.ccarFrom = {}
    }
  },
  watch: {
    ZPFrom: {
      handler (newName, oldName) {
        if (this.ZPFrom.pricingMethod == 1) {
          if (this.ZPFrom.weight && this.ZPFrom.unitPrice) {
            this.$set(this.ZPFrom, 'fatePrice', accMul(this.ZPFrom.weight, this.ZPFrom.unitPrice))
          } else {
            this.$set(this.ZPFrom, 'fatePrice', 0)
          }
        } else if (this.ZPFrom.pricingMethod == 2 && this.ZPFrom.unitPrice) {
          this.$set(this.ZPFrom, 'fatePrice', this.ZPFrom.unitPrice)
        }

        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
      // immediate: true
    }
  },
  destroyed () {
    this.dialog = false
  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-table .warning-row {
    background: #c4fbd2!important;
  }
  .redSpan {
  color: red;
  font-size: 18px;
}
.addressBox .title{
  margin-left: 0;
}
.addressBox{
  margin-top:16px;
  margin-bottom: -15px;
}
</style>
